import React from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section information-sectionmatchin">
        <div className="first-para" style={{ margin: "0" }}>
          <h2>
            {t("Dop-detail4")} <span></span>
          </h2>
          <p>
            {t('Matt1')}
          </p>
        </div>

        <div className="first-para" style={{ margin: "0" }}>
          <h2>
            {t('Matt2')}<span></span>
          </h2>
          <p>
            {t('Matt3')}
          </p>
          <p>{t('Matt4')}</p>
          <ul>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt5')}</span> {t('Matt6')}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt7')}</span> {t('Matt8')}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt9')}</span> {t('Matt10')}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt11')}</span>{" "}
              {t('Matt12')}
            </li>
          </ul>
        </div>

        <div className="first-para" style={{ margin: "0" }}>
          <h2>
           {t('Matt13')}<span></span>
          </h2>
          <p>
           {t('Matt14')}
          </p>
        </div>

        <div className="first-para" style={{ margin: "0" }}>
          <h2>
            {t('Matt15')}<span></span>
          </h2>
          <p>
            {t('Matt16')}
          </p>
        </div>

        <div className="first-para" style={{ margin: "0" }}>
          <h2>
            {t('Matt17')}<span></span>
          </h2>
          <p>
          {t('Matt18')}
          </p>
          <ol>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt19')}</span>{" "}
              {t('Matt20')}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>
              {t('Matt21')}
              </span>{" "}
              {t('Matt22')}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>{t('Matt23')}</span> 
              {t('Matt24')}
            </li>
          </ol>
          <p>
          {t('Matt25')}
          </p>
        </div>

        {window.innerWidth > 600 ? (
          <div className="first-para">
            <h2>
            {t('Matt26')}<span></span>
            </h2>
            <p>
            {t('Matt27')}
            </p>
            <div className="twice-tokenomics">
              <div className="tokenomic-img p-0">
                <img
                  src="\assets\alldetailpages\matchain\info\pstable.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\pstablelight.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="first-para">
            <h2>
              {t('Matt26')} <span></span>
            </h2>
            <p>
              {t('Matt27')}
            </p>
            <div className="twice-tokenomics">
              <div className="tokenomic-img p-0">
                <img
                  src="\assets\alldetailpages\matchain\info\pstablembl.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\pstablelightmbl.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
            </div>
          </div>
        )}

        <div className="first-para">
          <h2>
            {t('Inc-detailt34')} <span></span>
          </h2>
          <div className="team-gems">
            <div className="single-team">
              <img
                src="\assets\alldetailpages\matchain\banner\team\petrix.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">{t('Matt28')} </h6>
              <h5>{t('Matt29')}</h5>
              <p>
                {t('Matt30')}
              </p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\matchain\banner\team\tomasz.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">{t('Matt31')} </h6>
              <h5>{t('Matt32')}</h5>
              <p>
                {t('Matt33')}
              </p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\matchain\banner\team\jessie.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">{t('Matt34')} </h6>
              <h5>{t('Matt35')}</h5>
              <p>
                {t('Matt36')}
              </p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\matchain\banner\team\anastasia.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">{t('Matt37')} </h6>
              <h5>{t('Matt38')}</h5>
              <p>
                {t('Matt39')}
              </p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\matchain\banner\team\ricky.png"
                alt="img"
                className="img-fluid"
                style={{ objectPosition: "50%" }}
              />
              <h6 className="mb-0">{t('Matt40')} </h6>
              <h5>{t('Matt41')}</h5>
              <p>
                {t('Matt42')}
              </p>
            </div>
          </div>
        </div>

<div className="main-first-para">
{window.innerWidth > 600 ? (
          <div className="first-para">
            <h2>
              Matchain {t("Dop-detail31")} <span></span>
            </h2>
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt43')}</h4>
              <div className="centerimg">
                <img
                  src="\assets\alldetailpages\matchain\info\tokenomics.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\tokenomics-light.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts">
                <div className="mainvalue">
                  <span className="circle blue"></span>
                  <p className="innervalue">{t('Matt44')}</p>
                </div>
                <div className="mainvalue">
                  <span className="circle red"></span>
                  <p className="innervalue">{t('Matt45')}</p>
                </div>
                <div className="mainvalue">
                  <span className="circle grey"></span>
                  <p className="innervalue">{t('Matt46')}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="first-para">
            <h2>
              Matchain {t("Dop-detail31")} <span></span>
            </h2>
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt43')}</h4>
              <div className="centerimg">
                <img
                  src="\assets\alldetailpages\matchain\info\tokenomicsmbbll.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="/assets/alldetailpages/matchain/info/tokenomics-lightmbl.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts">
                <div className="mainvalue">
                  <span className="circle blue"></span>
                  <p className="innervalue">{t('Matt44')}</p>
                </div>
                <div className="mainvalue">
                  <span className="circle red"></span>
                  <p className="innervalue">{t('Matt45')}</p>
                </div>
                <div className="mainvalue">
                  <span className="circle grey"></span>
                  <p className="innervalue">{t('Matt46')}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {window.innerWidth > 600 ? (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt44')}</h4>
              <div className="centerimg">
                <img
                  src="\assets\alldetailpages\matchain\info\tokensupply.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\tokensupply-light.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              {/* <div className="centertexts">
                <div className="mainvalue">
                    <span className="circle blue"></span>
                    <p className="innervalue">{t('Matt44')}</p>
                </div>
                <div className="mainvalue">
                    <span className="circle red"></span>
                    <p className="innervalue">{t('Matt45')}</p>
                </div>
                <div className="mainvalue">
                    <span className="circle grey"></span>
                    <p className="innervalue">{t('Matt46')}</p>
                </div>
              </div> */}
            </div>
          </div>
        ) : (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt44')}</h4>
              <div className="centerimg">
                <img
                  src="/assets/alldetailpages/matchain/info/tokensuplymbl.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="/assets/alldetailpages/matchain/info/tokensupply-lightmbl.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts">
                <div className="mainvalue">
                  <span className="circle green"></span>
                  <p className="innervalue">
                    {t('Matt47')} <span className="percentage">34.2%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle orange"></span>
                  <p className="innervalue">
                    {t('Matt48')} <span className="percentage">26.3%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle red"></span>
                  <p className="innervalue">
                    {t('Matt49')} <span className="percentage">26.3%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle blue"></span>
                  <p className="innervalue">
                    {t('Matt50')} <span className="percentage">13.2%</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
</div>

<div className="main-first-para">
        {window.innerWidth > 600 ? (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt45')}</h4>
              <div className="centerimg">
                <img
                  src="\assets\alldetailpages\matchain\info\pools.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\pools-light.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              {/* <div className="centertexts">
                <div className="mainvalue">
                    <span className="circle blue"></span>
                    <p className="innervalue">{t('Matt44')}</p>
                </div>
                <div className="mainvalue">
                    <span className="circle red"></span>
                    <p className="innervalue">{t('Matt45')}</p>
                </div>
                <div className="mainvalue">
                    <span className="circle grey"></span>
                    <p className="innervalue">{t('Matt46')}</p>
                </div>
              </div> */}
            </div>
          </div>
        ) : (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt45')}</h4>
              <div className="centerimg">
                <img
                  src="/assets/alldetailpages/matchain/info/poolsmbl.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="/assets/alldetailpages/matchain/info/pools-lightmbl.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts" style={{gap : '18px 15px'}}>
                <div className="mainvalue">
                  <span className="circle grey"></span>
                  <p className="innervalue">
                  {t('Matt51')} <span className="percentage">66.7%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle neworange"></span>
                  <p className="innervalue">
                  {t('Matt52')} <span className="percentage">23.8%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle yellow"></span>
                  <p className="innervalue">
                  {t('Matt53')} <span className="percentage">4.8%</span>
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="circle white"></span>
                  <p className="innervalue">
                  {t('Matt54')} <span className="percentage">4.8%</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}


{window.innerWidth > 600 ? (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt55')}</h4>
              <div className="centerimg">
                <img
                  src="\assets\alldetailpages\matchain\info\supply.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="\assets\alldetailpages\matchain\info\supply-light.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts">
                <div className="mainvalue">
                  <span className="square blue"></span>
                  <p className="innervalue">
                  {t('Matt50')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newwhite"></span>
                  <p className="innervalue">
                  {t('Matt57')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newgreen"></span>
                  <p className="innervalue">
                  {t('Matt47')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square red"></span>
                  <p className="innervalue">
                  {t('Matt49')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newred"></span>
                  <p className="innervalue">
                  {t('Matt58')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newyellow"></span>
                  <p className="innervalue">
                  {t('Matt48')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="first-para">
            <div className="newtokenomics">
              <h4 className="innerhead">{t('Matt55')}</h4>
              <div className="centerimg">
                <img
                  src="/assets/alldetailpages/matchain/info/supplymbl.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  src="/assets/alldetailpages/matchain/info/supply-lightmbl.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
              <div className="centertexts">
                <div className="mainvalue">
                  <span className="square blue"></span>
                  <p className="innervalue">
                  {t('Matt50')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newwhite"></span>
                  <p className="innervalue">
                  {t('Matt57')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newgreen"></span>
                  <p className="innervalue">
                  {t('Matt47')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square red"></span>
                  <p className="innervalue">
                  {t('Matt49')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newred"></span>
                  <p className="innervalue">
                  {t('Matt58')}
                  </p>
                </div>
                <div className="mainvalue">
                  <span className="square newyellow"></span>
                  <p className="innervalue">
                  {t('Matt48')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
</div>
        {/* {
                    window.innerWidth > 600 ? <div className="first-para">
                        <h2>{t('Distandallocation')} <span></span></h2>
                        <div className="twice-tokenomics">
                            <div className="tokenomic-img p-0">
                                <img src="\assets\alldetailpages\matchain\info\distribution.png" alt="img" className='img-fluid hide-in-light-theme' />
                                <img src="\assets\alldetailpages\matchain\info\distribution-light.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                            </div>
                        </div>
                    </div> : <div className="first-para">
                        <h2>{t('Distandallocation')} <span></span></h2>
                        <div className="twice-tokenomics">
                            <div className="tokenomic-img p-0">
                                <img src="\assets\alldetailpages\matchain\info\distributionmbl.png" alt="img" className='img-fluid hide-in-light-theme' />
                                <img src="\assets\alldetailpages\matchain\info\distribution-lightmbl.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                            </div>
                        </div>
                    </div>
                } */}
      </section>
    </>
  );
};

export default Information;
